module.exports = __webpack_public_path__ + "img/modal-folios-upload.502e1f85.svg";